// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--d155e";
export var footer__bottom = "footer-module--footer__bottom--ee31a";
export var footer__bottom__links = "footer-module--footer__bottom__links--93134";
export var footer__social = "footer-module--footer__social--ebfbf";
export var footer__top = "footer-module--footer__top--8ec57";
export var x = "footer-module--x--02124";